import { useContext } from 'react';
import { ToastContext } from '../context/ToastContext';

export const UseToast = () => {
  const context = useContext(ToastContext);
  if (!context) {
    throw new Error('UseToast must be used within ToastProvider');
  }
  return context.toast;
};